module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"<span class=\\"color-green\\">Press</span> review"},"fr":{"title":"On parle de Ween dans <span class=\\"color-green\\">les medias</span>"}}')
  delete Component.options._Ctor
}
